export function initializeClientIframe() {
    let client = '.client-preview';

    $(client).on('load', function () {
        previewHeight();

        $(window).resize(function () {
            previewHeight();
        })

        preview();
    });

    function preview() {
        $(client).contents().find('.sticky-cart').remove();
        $(client).contents().find('.btn-floating-donation').remove();
        $(client).contents().find('.btn-quick-access-admin').remove();
        $(client).contents().find('.platform-ad').remove();

        let headerPreview = '.header-container .layout-preview';
        $(headerPreview).contents().find('main').remove();
        $(headerPreview).contents().find('footer').remove();

        let footerPreview = '.footer-container .layout-preview';
        $(footerPreview).contents().find('header').remove();
        $(footerPreview).contents().find('main').remove();
        $(footerPreview).contents().find('body').css('padding-top', '0');

        $(client).contents().find('body').addClass('builder-preview');
        $('.app-drawer-wrapper').addClass('drawer-open');

        visualizer();
    }

    function visualizer() {
        $(client).contents().find('header').on('mouseenter, mouseover', function () {
            $(this).addClass('builder-visualize-header');

            $(this).on('click', function () {
                window.location.replace($(this).data('header'));
            });

            $(this).on('mouseleave', function () {
                $(this).removeClass('builder-visualize-header');
            });
        });

        $(client).contents().find('section').on('mouseenter, mouseover', function () {
            $(this).addClass('builder-visualize-section');

            $(this).on('click', function () {
                window.location.href = $(client).data('page') + '#section-' + $(this).attr('id');
            });

            let section = '.app-drawer-wrapper [data-uuid="' + $(this).attr('id') + '"]';
            $(section).addClass('visualize-section');

            $(this).on('mouseleave', function () {
                $(this).removeClass('builder-visualize-section');
                $(section).removeClass('visualize-section');
            });
        });

        $(client).contents().find('.block-container').on('mouseenter, mouseover', function () {
            $(this).addClass('builder-visualize-block');

            $(this).on('click', function () {
                window.location.href = $(client).data('page') + '#block-' + $(this).attr('id');
            });

            let blockFull = $(this).attr('id');
            let blockId = blockFull.replace('block-', '');
            let block = '.app-drawer-wrapper [data-uuid="' + blockId + '"]';
            $(block).addClass('visualize-block');

            $(this).on('mouseleave', function () {
                $(this).removeClass('builder-visualize-block');
                $(block).removeClass('visualize-block');
            });
        });

        $(client).contents().find('footer').on('mouseenter, mouseover', function () {
            $(this).addClass('builder-visualize-footer');

            $(this).on('click', function () {
                window.location.replace($(this).data('footer'));
            });

            $(this).on('mouseleave', function () {
                $(this).removeClass('builder-visualize-footer');
            });
        });

        drawer();
    }

    function drawer() {
        $('.builder-bar-btn').on('click', function () {
            $('.app-drawer-wrapper').toggleClass('drawer-open');
        });

        $('.start-tour').on('click', function () {
            $('.app-drawer-wrapper').addClass('drawer-open');
        });

        scroll();
    }

    function scroll() {
        $(document).scrollTop($(document).height());

        container();
    }

    function container() {

        $(client).contents().find('section').each(function () {
            $(this).append('<div class="builder-section-identifier"></div>');
        });

        $(client).contents().find('.builder-section-identifier').on('click', function (e) {
            let url = $(this).parent().data('section');
            e.preventDefault();
            callModal(url);
        })

        $(client).contents().find('.block-container').each(function () {
            let self = this;
            $(this).on('click', function (e) {
                let url = $(self).data('block');
                e.preventDefault();
                callModal(url);
            });
        });

    }

    /**
     * Call modal
     *
     * @param url
     */
    function callModal(url) {
        let modal = $('#modal');
        new Load(true);
        $.ajax({
            url: url,
            type: 'GET',
            success: function (data) {
                modal.find('.modal-dialog').html(data.view);

                if (modal.find('.modal-dialog').hasClass('modal-')) {
                    modal.find('.modal-dialog').removeClass('modal-');
                }

                if (typeof data.size !== "undefined") {
                    modal.find('.modal-dialog').addClass('modal-' + data.size);
                } else {
                    let sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
                    sizes.forEach(function (size) {
                        if (modal.find('.modal-dialog').hasClass('modal-' + size)) {
                            modal.find('.modal-dialog').removeClass('modal-' + size);
                        }
                    });
                }

                setTimeout(function () {
                    if (!modal.hasClass('show')) {
                        modal.modal('show');
                    }
                }, 100);

                initializePlugins(false);
                new Load(false);
            },
            error: function (data) {
                new Load(false);
                let response = JSON.parse(data.responseText);
                Notification.message("Error", response.message, 'danger', 2000);
            }
        });
    }

}

function previewHeight() {
    let layout = '.layout-preview';

    let headerHeight = $(layout).contents().find('header nav').outerHeight();
    let footerHeight = $(layout).contents().find('footer').outerHeight();

    $('.header-container').css('height', headerHeight + 'px');
    $('.footer-container').css('height', footerHeight + 'px');
}
